import AccountsTag from "common/components/ui/AccountsTag";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useWorkspaceAccounts from "common/datahooks/useWorkspaceAccounts";

import type { ReactNode } from "react";

interface LinkedInAccountsLabelProps {
  accountIds: string[];
  size: "md" | "sm";
}

export default function LinkedInAccountsTag({
  accountIds,
  size = "md",
}: LinkedInAccountsLabelProps) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { workspaceAccounts, isLoadingWorkspaceAccounts } =
    useWorkspaceAccounts(workspaceId);

  const accounts = workspaceAccounts.filter(({ id }) =>
    accountIds.includes(id),
  );

  let tagText: string;
  let tooltipContent: ReactNode;

  if (accounts.length === 1) {
    const { full_name: fullName } = accounts[0];
    tagText = fullName;
  } else {
    tagText = `${accounts.length} accounts`;
    tooltipContent = accounts.map(({ full_name: fullName, id }) => (
      <span key={id}>
        {fullName}
        <br />
      </span>
    ));
  }

  return (
    <AccountsTag
      accounts={accounts}
      variant="purple"
      size={size}
      isLoading={isLoadingWorkspaceAccounts}
      tooltipContent={tooltipContent}
    >
      {tagText}
    </AccountsTag>
  );
}
